// FETCH ALL PROPERTIES FROM SALES_ORDER PAGE
export const FETCH_SALES_ORDER_REQUEST = 'FETCH_SALES_ORDER_REQUEST';
export const FETCH_SALES_ORDER_SUCCESS = 'FETCH_SALES_ORDER_SUCCESS';
export const FETCH_SALES_ORDER_FAILURE = 'FETCH_SALES_ORDER_FAILURE';

export const FETCH_SALES_ORDER_BUYER_NAME_REQUEST = 'FETCH_SALES_ORDER_BUYER_NAME_REQUEST';
export const FETCH_SALES_ORDER_BUYER_NAME_SUCCESS = 'FETCH_SALES_ORDER_BUYER_NAME_SUCCESS';
export const FETCH_SALES_ORDER_BUYER_NAME_FAILURE = 'FETCH_SALES_ORDER_BUYER_NAME_FAILURE';

export const CLOSED_OCR_REPORTS_REQUEST = 'CLOSED_OCR_REPORTS_REQUEST';
export const CLOSED_OCR_REPORTS_SUCCESS = 'CLOSED_OCR_REPORTS_SUCCESS';
export const CLOSED_OCR_REPORTS_FAILURE = 'CLOSED_OCR_REPORTS_FAILURE';

// CREATE PROPERTIES FOR SALES_ORDER PAGE
export const CREATE_SALES_ORDER_REQUEST = 'CREATE_SALES_ORDER_REQUEST';
export const CREATE_SALES_ORDER_SUCCESS = 'CREATE_SALES_ORDER_SUCCESS';
export const CREATE_SALES_ORDER_FAILURE = 'CREATE_SALES_ORDER_FAILURE';

export const DISPATCH_SALES_ORDER_REQUEST = 'DISPATCH_SALES_ORDER_REQUEST';
export const DISPATCH_SALES_ORDER_SUCCESS = 'DISPATCH_SALES_ORDER_SUCCESS';
export const DISPATCH_SALES_ORDER_FAILURE = 'DISPATCH_SALES_ORDER_FAILURE';

export const DISPATCH_SALES_ORDER_FINAL_REQUEST = 'DISPATCH_SALES_ORDER_FINAL_REQUEST';
export const DISPATCH_SALES_ORDER_FINAL_SUCCESS = 'DISPATCH_SALES_ORDER_FINAL_SUCCESS';
export const DISPATCH_SALES_ORDER_FINAL_FAILURE = 'DISPATCH_SALES_ORDER_FINAL_FAILURE';

// UPDATE PROPERTIES FOR SALES_ORDER PAGE
export const UPDATE_SALES_ORDER_REQUEST = 'UPDATE_SALES_ORDER_REQUEST';
export const UPDATE_SALES_ORDER_SUCCESS = 'UPDATE_SALES_ORDER_SUCCESS';
export const UPDATE_SALES_ORDER_FAILURE = 'UPDATE_SALES_ORDER_FAILURE';

// FETCH SINGLE PROPERTY FOR SALES_ORDER PAGE
export const FETCH_SINGLE_SALES_ORDER_REQUEST = 'FETCH_SINGLE_SALES_ORDER_REQUEST';
export const FETCH_SINGLE_SALES_ORDER_SUCCESS = 'FETCH_SINGLE_SALES_ORDER_SUCCESS';
export const FETCH_SINGLE_SALES_ORDER_FAILURE = 'FETCH_SINGLE_SALES_ORDER_FAILURE';

// DELETE PROPERTIES FOR SALES_ORDER PAGE
export const DELETE_SALES_ORDER_REQUEST = 'DELETE_SALES_ORDER_REQUEST';
export const DELETE_SALES_ORDER_SUCCESS = 'DELETE_SALES_ORDER_SUCCESS';
export const DELETE_SALES_ORDER_FAILURE = 'DELETE_SALES_ORDER_FAILURE';

export const CANCEL_SALES_ORDER_REQUEST = 'CANCEL_SALES_ORDER_REQUEST';
export const CANCEL_SALES_ORDER_SUCCESS = 'CANCEL_SALES_ORDER_SUCCESS';
export const CANCEL_SALES_ORDER_FAILURE = 'CANCEL_SALES_ORDER_FAILURE';

export const CREATE_USER_FORM_SALES_ORDER = 'CREATE_USER_FORM_SALES_ORDER';
export const SALES_ORDER_USERFORM_RESET = 'SALES_ORDER_USERFORM_RESET';
export const SALES_ORDER_USERFORM_DROPDOWNLIST_RESET = 'SALES_ORDER_USERFORM_DROPDOWNLIST_RESET';

export const FETCH_DEMAND_APPROVAL_STATUS_REQUEST = 'FETCH_DEMAND_APPROVAL_STATUS_REQUEST';
export const FETCH_DEMAND_APPROVAL_STATUS_SUCCESS = 'FETCH_DEMAND_APPROVAL_STATUS_SUCCESS';
export const FETCH_DEMAND_APPROVAL_STATUS_FAILURE = 'FETCH_DEMAND_APPROVAL_STATUS_FAILURE';

export const FETCH_DEMAND_STATUS_REQUEST = 'FETCH_DEMAND_STATUS_REQUEST';
export const FETCH_DEMAND_STATUS_SUCCESS = 'FETCH_DEMAND_STATUS_SUCCESS';
export const FETCH_DEMAND_STATUS_FAILURE = 'FETCH_DEMAND_STATUS_FAILURE';
export const RESET_DEMAND_STATUS = 'RESET_DEMAND_STATUS';

export const FETCH_DEMAND_APPROVAL_SUMMARY_REQUEST = 'FETCH_DEMAND_APPROVAL_SUMMARY_REQUEST';
export const FETCH_DEMAND_APPROVAL_SUMMARY_SUCCESS = 'FETCH_DEMAND_APPROVAL_SUMMARY_SUCCESS';
export const FETCH_DEMAND_APPROVAL_SUMMARY_FAILURE = 'FETCH_DEMAND_APPROVAL_SUMMARY_FAILURE';

export const FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_REQUEST = 'FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_REQUEST';
export const FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_SUCCESS = 'FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_SUCCESS';
export const FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_FAILURE = 'FETCH_STYLE_DETAIL_APPROVAL_SUMMARY_FAILURE';

export const FETCH_STYLE_DETAIL_APPROVAL_HEADER_REQUEST = 'FETCH_STYLE_DETAIL_APPROVAL_HEADER_REQUEST';
export const FETCH_STYLE_DETAIL_APPROVAL_HEADER_SUCCESS = 'FETCH_STYLE_DETAIL_APPROVAL_HEADER_SUCCESS';
export const FETCH_STYLE_DETAIL_APPROVAL_HEADER_FAILURE = 'FETCH_STYLE_DETAIL_APPROVAL_HEADER_FAILURE';

export const FETCH_STYLE_DETAIL_APPROVAL_DETAIL_REQUEST = 'FETCH_STYLE_DETAIL_APPROVAL_DETAIL_REQUEST';
export const FETCH_STYLE_DETAIL_APPROVAL_DETAIL_SUCCESS = 'FETCH_STYLE_DETAIL_APPROVAL_DETAIL_SUCCESS';
export const FETCH_STYLE_DETAIL_APPROVAL_DETAIL_FAILURE = 'FETCH_STYLE_DETAIL_APPROVAL_DETAIL_FAILURE';

export const FETCH_STYLE_DETAIL_APPROVAL_STYLE_REQUEST = 'FETCH_STYLE_DETAIL_APPROVAL_STYLE_REQUEST';
export const FETCH_STYLE_DETAIL_APPROVAL_STYLE_SUCCESS = 'FETCH_STYLE_DETAIL_APPROVAL_STYLE_SUCCESS';
export const FETCH_STYLE_DETAIL_APPROVAL_STYLE_FAILURE = 'FETCH_STYLE_DETAIL_APPROVAL_STYLE_FAILURE';

export const UPDATE_STYLE_DETAIL_APPROVAL_STATUS_REQUEST = 'UPDATE_STYLE_DETAIL_APPROVAL_STATUS_REQUEST';
export const UPDATE_STYLE_DETAIL_APPROVAL_STATUS_SUCCESS = 'UPDATE_STYLE_DETAIL_APPROVAL_STATUS_SUCCESS';
export const UPDATE_STYLE_DETAIL_APPROVAL_STATUS_FAILURE = 'UPDATE_STYLE_DETAIL_APPROVAL_STATUS_FAILURE';

// navigate to access info page
export const NAVIGATE_SALES_ORDER = 'NAVIGATE_SALES_ORDER';
// navigate to access details page
export const NAVIGATE_SALES_ORDER_DETAILS = 'NAVIGATE_SALES_ORDER_DETAILS';
export const NAVIGATE_SALES_ORDER_DEMAND = 'NAVIGATE_SALES_ORDER_DEMAND';
export const CC_TOGGLE = 'CC_TOGGLE';
export const DEMAND_TOGGLE = 'DEMAND_TOGGLE';
export const DEMAND_RESET = 'DEMAND_RESET';

export const DEMAND_TOGGLE_DUMMY = 'DEMAND_TOGGLE_DUMMY';





export const SALES_ORDER_CALL_POST_REQUEST = 'SALES_ORDER_CALL_POST'
export const SALES_ORDER_CALL_POST_SUCCESS = 'SALES_ORDER_CALL_POST_SUCCESS'
export const SALES_ORDER_CALL_POST_FAILURE = 'SALES_ORDER_CALL_POST_FAILURE'


export const ACCESSORIES_POST_CALL_REQUEST = 'ACCESSORIES_POST_CALL_REQUEST'
export const ACCESSORIES_POST_CALL_SUCCESS = 'ACCESSORIES_POST_CALL_SUCCESS'
export const ACCESSORIES_POST_CALL_FAILURE = 'ACCESSORIES_POST_CALL_FAILURE'

export const SALES_ORDER_GET_STYLE_STATUS_REQUEST = 'SALES_ORDER_GET_STYLE_STATUS_REQUEST'
export const SALES_ORDER_GET_STYLE_STATUS_SUCCESS = 'SALES_ORDER_GET_STYLE_STATUS_SUCCESS'
export const SALES_ORDER_GET_STYLE_STATUS_FAILURE = 'SALES_ORDER_GET_STYLE_STATUS_FAILURE'

export const FETCH_SALES_ORDER_COMPARE_REQUEST = 'FETCH_SALES_ORDER_COMPARE_REQUEST'
export const FETCH_SALES_ORDER_COMPARE_SUCCESS = 'FETCH_SALES_ORDER_COMPARE_SUCCESS'
export const FETCH_SALES_ORDER_COMPARE_FAILURE = 'FETCH_SALES_ORDER_COMPARE_FAILURE'

export const LOADING_SALES_ORDER_DEMAND = 'LOADING_SALES_ORDER_DEMAND'

export const FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_REQUEST = 'FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_REQUEST'
export const FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_SUCCESS = 'FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_SUCCESS'
export const FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_FAILURE = 'FETCH_SALES_ORDER_COSTING_COMPARISION_DATA_FAILURE'

export const SET_RADIO_BTN_SALES_ORDER_COMPARISION = 'SET_RADIO_BTN_SALES_ORDER_COMPARISION'

export const FETCH_COSTING_COMPARISION_PERIOD_WISE_REQUEST = 'FETCH_COSTING_COMPARISION_PERIOD_WISE_REQUEST'
export const FETCH_COSTING_COMPARISION_PERIOD_WISE_SUCCESS = 'FETCH_COSTING_COMPARISION_PERIOD_WISE_SUCCESS'
export const FETCH_COSTING_COMPARISION_PERIOD_WISE_FAILURE = 'FETCH_COSTING_COMPARISION_PERIOD_WISE_FAILURE'

export const FETCH_GENERATE_COSTING_FABRIC_TABLE1_REQUEST = 'FETCH_GENERATE_COSTING_FABRIC_TABLE1_REQUEST'
export const FETCH_GENERATE_COSTING_FABRIC_TABLE1_SUCCESS = 'FETCH_GENERATE_COSTING_FABRIC_TABLE1_SUCCESS'
export const FETCH_GENERATE_COSTING_FABRIC_TABLE1_FAILURE = 'FETCH_GENERATE_COSTING_FABRIC_TABLE1_FAILURE'

export const FETCH_GENERATE_COSTING_FABRIC_TABLE2_REQUEST = 'FETCH_GENERATE_COSTING_FABRIC_TABLE2_REQUEST'
export const FETCH_GENERATE_COSTING_FABRIC_TABLE2_SUCCESS = 'FETCH_GENERATE_COSTING_FABRIC_TABLE2_SUCCESS'
export const FETCH_GENERATE_COSTING_FABRIC_TABLE2_FAILURE = 'FETCH_GENERATE_COSTING_FABRIC_TABLE2_FAILURE'

export const CREATE_FABRIC_AUTHORIZE_SALES_ORDER_REQUEST = 'CREATE_FABRIC_AUTHORIZE_SALES_ORDER_REQUEST';
export const CREATE_FABRIC_AUTHORIZE_SALES_ORDER_SUCCESS = 'CREATE_FABRIC_AUTHORIZE_SALES_ORDER_SUCCESS';
export const CREATE_FABRIC_AUTHORIZE_SALES_ORDER_FAILURE = 'CREATE_FABRIC_AUTHORIZE_SALES_ORDER_FAILURE';


export const CREATE_MERCH_AUTHORIZE_SALES_ORDER_REQUEST = 'CREATE_MERCH_AUTHORIZE_SALES_ORDER_REQUEST';
export const CREATE_MERCH_AUTHORIZE_SALES_ORDER_SUCCESS = 'CREATE_MERCH_AUTHORIZE_SALES_ORDER_SUCCESS';
export const CREATE_MERCH_AUTHORIZE_SALES_ORDER_FAILURE = 'CREATE_MERCH_AUTHORIZE_SALES_ORDER_FAILURE';



export const FETCH_GENERATE_COSTING_FABRIC_TABLE3_REQUEST = 'FETCH_GENERATE_COSTING_FABRIC_TABLE3_REQUEST'
export const FETCH_GENERATE_COSTING_FABRIC_TABLE3_SUCCESS = 'FETCH_GENERATE_COSTING_FABRIC_TABLE3_SUCCESS'
export const FETCH_GENERATE_COSTING_FABRIC_TABLE3_FAILURE = 'FETCH_GENERATE_COSTING_FABRIC_TABLE3_FAILURE'


export const CHECK_AUTHORIZE_SALES_ORDER_REQUEST = 'CHECK_AUTHORIZE_SALES_ORDER_REQUEST';
export const CHECK_AUTHORIZE_SALES_ORDER_SUCCESS = 'CHECK_AUTHORIZE_SALES_ORDER_SUCCESS';
export const CHECK_AUTHORIZE_SALES_ORDER_FAILURE = 'CHECK_AUTHORIZE_SALES_ORDER_FAILURE';


export const USER_BASED_LOAD_SALES_ORDER_REQUEST = 'USER_BASED_LOAD_SALES_ORDER_REQUEST';
export const USER_BASED_LOAD_SALES_ORDER_SUCCESS = 'USER_BASED_LOAD_SALES_ORDER_SUCCESS';
export const USER_BASED_LOAD_SALES_ORDER_FAILURE = 'USER_BASED_LOAD_SALES_ORDER_FAILURE';


export const ACCESS_OCR_LOAD_SALES_ORDER_REQUEST = 'ACCESS_OCR_LOAD_SALES_ORDER_REQUEST';
export const ACCESS_OCR_LOAD_SALES_ORDER_SUCCESS = 'ACCESS_OCR_LOAD_SALES_ORDER_SUCCESS';
export const ACCESS_OCR_LOAD_SALES_ORDER_FAILURE = 'ACCESS_OCR_LOAD_SALES_ORDER_FAILURE';

export const ACCESS_OCR_TRANS_SALES_ORDER_REQUEST = 'ACCESS_OCR_TRANS_SALES_ORDER_REQUEST';
export const ACCESS_OCR_TRANS_SALES_ORDER_SUCCESS = 'ACCESS_OCR_TRANS_SALES_ORDER_SUCCESS';
export const ACCESS_OCR_TRANS_SALES_ORDER_FAILURE = 'ACCESS_OCR_TRANS_SALES_ORDER_FAILURE';

export const RESET_DATA_VERIFICATIONS = 'RESET_DATA_VERIFICATIONS';
export const ACCESS_OCR_TRANS_SALES_ORDER_RESET = 'ACCESS_OCR_TRANS_SALES_ORDER_RESET';

export const FETCH_STYLE_MASTER_BY_TEMPLATE_REQUEST = 'FETCH_STYLE_MASTER_BY_TEMPLATE_REQUEST';
export const FETCH_STYLE_MASTER_BY_TEMPLATE_SUCCESS = 'FETCH_STYLE_MASTER_BY_TEMPLATE_SUCCESS';
export const FETCH_STYLE_MASTER_BY_TEMPLATE_FAILURE = 'FETCH_STYLE_MASTER_BY_TEMPLATE_FAILURE';

export const FETCH_STYLE_MASTER_BY_PCS_WEIGHT_REQUEST = 'FETCH_STYLE_MASTER_BY_PCS_WEIGHT_REQUEST';
export const FETCH_STYLE_MASTER_BY_PCS_WEIGHT_SUCCESS = 'FETCH_STYLE_MASTER_BY_PCS_WEIGHT_SUCCESS';
export const FETCH_STYLE_MASTER_BY_PCS_WEIGHT_FAILURE = 'FETCH_STYLE_MASTER_BY_PCS_WEIGHT_FAILURE';

export const RESET_OCR_DATA = 'RESET_OCR_DATA';


export const FETCH_SALES_ORDER_REQUEST_NEW = 'FETCH_SALES_ORDER_REQUEST_NEW';
export const FETCH_SALES_ORDER_SUCCESS_NEW = 'FETCH_SALES_ORDER_SUCCESS_NEW';
export const FETCH_SALES_ORDER_FAILURE_NEW = 'FETCH_SALES_ORDER_FAILURE_NEW';



